// extracted by mini-css-extract-plugin
export default {"title":"oem_title__Ru01P","item":"oem_item__589o2","label":"oem_label__APzsN","value":"oem_value__9yrrG","mobile":"oem_mobile__asw1Y","tablet":"oem_tablet__rNcot"};